import { ValidationRuleType } from "devextreme/common";
import {LookupItem, ParamDto, ValidatorDto} from "./ortak.dtos";
import {SummaryType} from "devextreme/common/grids";

export interface ColumnModel {
  dataField?: string;
  caption?: string;
  dataType?: string;
  format?: any;
  width?: string;
  hidingPriority?: number;
  type?: number;
  maxWidth?: string;
  groupIndex?: number;
  sortIndex?: number;
  sortOrder?: string;
  visible?: boolean;
  visibleIndex?:number
  fixed?:boolean
  fixedPosition?:string;
  lookup?:string;
  allowHiding?:boolean;
  allowFiltering?:boolean;
  allowSorting?:boolean;
  allowGrouping?:boolean;
  column?:string;
  summaryType?:string;
  valueFormat?:string;
  name?:string;
  allowEditing?:boolean;
  hasItem?:boolean;
  viewTemplate?:string;
  defaultFilter?:any;
  dataLength?:number;
  options?:ParamDto[];
  validators?: ValidatorDto[];
  /**
   * DevExtreme kolonu için opsiyonel setCellValue callback'i.
   * Batch/cell edit modunda bir hücre düzenlenirken bağlı (hesaplanan) hücreleri
   * editörü bozmadan güncellemek için kullanılır. `cellValue` ile dışarıdan repaint
   * tetiklemek editörü yeniden oluşturup focus/ondalık girişini bozduğundan tercih edilir.
   */
  setCellValue?: (newData: any, value: any, currentRowData: any) => void;
}

export interface SumModel {
  sumLabel: string;
  sumValue: number;
}



export interface ButtonOppModel {
  text: string;
  type: string;
  useSubmitBehavior:  boolean;
  stylingMode?: string;
}

export class TebDonemModel {
  Ad: string;
  BelediyeKod: number;
  DegisKullaniciKod: number;
  DegisTarih: Date;
  KayitKullaniciKod: number;
  KayitTarih: Date;
  Kod: number;
  Yil: number;
  Yil1Oran: number;
  Yil2Oran: number;
  GenBelediye: any;
  ProgramButceEh: string;
  AktifEh: string;

  constructor(item?: any) {
    this.Ad = item?.Ad || '';
    this.BelediyeKod = item?.BelediyeKod || 0;
    this.DegisKullaniciKod = item?.DegisKullaniciKod || 0;
    this.DegisTarih = item?.DegisTarih || new Date();
    this.KayitKullaniciKod = item?.KayitKullaniciKod || 0;
    this.KayitTarih = item?.KayitTarih || new Date();
    this.Kod = item?.Kod || 0;
    this.Yil = item?.Yil || null;
    this.Yil1Oran = item?.Yil1Oran || null;
    this.Yil2Oran = item?.Yil2Oran || null;
    this.GenBelediye = item?.GenBelediye || null;
    this.ProgramButceEh = item?.ProgramButceEh || 'E';
    this.AktifEh = item?.AktifEh || 'H';
  }
}

export class OtherButtons {
  Icon: string;
  Tooltip: string;
}
export enum ColumnTypes {
  genericColumn = 0,
  editButtonColumn = 1,
  deleteButtonColumn = 2,
  dateColumn = 3,
  bothDeleteEditButton = 4,
  detailButtonColumn = 5,
  currencyColumn = 6,
  previewButtonColumn = 7,
  addButtonColumn = 8,
  lookupColumn = 11,
  TeklifVer = 12,
  MuayeneGir = 13,
  MuayeneDetayGor = 14,
  ColumnWithButton = 15

}


export interface SumListItem {
  column: string;
  name?: string;
  summaryType?: SummaryType;
  valueFormat?: Format | string | undefined;
}

export class LookupModel {
  lookupAd?: string
  data?: LookupItem[]
}

export type Format = 'currency' | 'percentage' | 'number' | 'custom';
